import { render, staticRenderFns } from "./StatisticsProgramLaw.vue?vue&type=template&id=d6eee288&"
import script from "./StatisticsProgramLaw.vue?vue&type=script&lang=js&"
export * from "./StatisticsProgramLaw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports